import { Component } from "@angular/core";



@Component({
  templateUrl: './catalogs.install.component.html'
})

export class CatalogsInstallComponent {

}
